export default "__VITE_ASSET__92d1fe29__"